import React from 'react';
import GenreReportTemplate from './GenreReportTemplate';
import { fetchProgramsByCategoryKeywords } from '../reportsApi';
import type { ReportComponentProps } from '../reportDefinitions';

const DEFAULT_KEYWORDS = ['christian', 'faith', 'gospel'];

const ChristianProgramsReport: React.FC<ReportComponentProps> = () => {
  return (
    <GenreReportTemplate
      reportId="christian-programs"
      defaultKeywords={DEFAULT_KEYWORDS}
      fetcher={(keywords) =>
        fetchProgramsByCategoryKeywords(keywords, {
          reportId: 'christian-programs',
          includeProgramMetadata: true,
          excludedBaciCodes: ['HCA']
        })
      }
      title="Programs featuring Christian-focused categories"
      subtitle="Programs highlighted here include categories referencing Christian authorship, faith-based content, or gospel themes."
      emptyMessage="No Christian-aligned programs were found. Try adjusting the keyword set and refreshing the report."
      emphasisNote="Keyword search applies to category display names, tier labels, awarding organizations, and program names; update the list above to refine."
      noteLabel="christian"
    />
  );
};

export default ChristianProgramsReport;
